import { c } from '../../../utils/tailwind-merge';
import { AlertProps } from './Alert.types';

export const Alert = ({ label, className = '' }: AlertProps) => {
  return (
    <div
      role="alert"
      className={c(
        'rounded-lg bg-surface-muted p-4 text-center text-sm text-content',
        className
      )}
    >
      {label}
    </div>
  );
};
